import { MdClose, MdEdit } from 'react-icons/md';
import { toast } from 'App';
import { adminsService } from 'views/services/adminsService';

export const AdminItem = ({
  admin,
}: {
  admin: any;
}) => {
  const handleDelete = async () => {
    try {
      if (window.confirm(`Are you sure you want to delete admin?`)) {
        await adminsService.deleteAdmin(admin.id);
        await adminsService.getAdminsList();
        toast({
          title: "Success",
          description: 'Admin successfully deleted',
          status: "success",
          position: "top-right",
        });
      }
    } catch (e) {
      console.warn(e);
    }
  };
  return (
    <div className="flex flex-row justify-between border gap-1 rounded-xl p-2 items-center text-sm">
      <p className="w-5/6">{admin.email}</p>

      <div className="flex flx-row gap-1">
        <button
          type="button"
          className="right-[10px] top-[10px] inline-flex h-[25px] w-[25px] appearance-none items-center justify-center rounded-full focus:outline-none"
          aria-label="Close"
          onClick={handleDelete}
        >
          <MdClose />
        </button>
      </div>
    </div>
  );
};
